import {
  ISegmentCurationStatus,
  ISegmentCurationType,
  IPaginationResponseDto,
  ISegmentCurationAbTest,
  ISegmentAbtestUpdateRequestDto,
  ISegmentCurationAbTestRequest,
  IABTest,
  IABTestBundlePackageDto,
  IApiResult,
  IBundlePackage,
} from '../types';
import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import api from './base';

export function getUserSegmentAbtests<T extends any>(
  status: ISegmentCurationStatus | 'all',
  type: ISegmentCurationType,
  page = 1,
  limit = 10,
): [Promise<AxiosResponse<IPaginationResponseDto<T>>>, Canceler] {
  const uri = `${settings.getApiURI()}/abtest-admin/v1/abtests`;
  const params =
    status !== 'all'
      ? { status, type: 'HOME_CURATION', curationType: type, page, limit }
      : { type: 'HOME_CURATION', curationType: type, page, limit };

  return api.getWithCancel(uri, {
    params,
  });
}

export function getUserSegmentAbtest(abtestId: number): [Promise<AxiosResponse<ISegmentCurationAbTest>>, Canceler] {
  const uri = `${settings.getApiURI()}/abtest-admin/v1/abtests/${abtestId}`;

  return api.getWithCancel(uri, {});
}

export function updateUserSegmentAbtest(abtestId: number, data: ISegmentAbtestUpdateRequestDto) {
  const uri = `${settings.getApiURI()}/abtest-admin/v1/abtests/${abtestId}`;
  return api.http.put(uri, data);
}

export function deleteUserSegmentAbtest(abtestId: number) {
  const uri = `${settings.getApiURI()}/abtest-admin/v1/abtests/${abtestId}`;
  return api.http.delete(uri);
}

export function saveUserSegmentCurationAbtest(curationId: number, data: ISegmentCurationAbTestRequest) {
  const uri = `${settings.getApiURI()}/abtest-admin/v1/home-curations/${curationId}/abtests`;
  return api.http.patch(uri, data);
}

export function getAbtestList(params: {
  page?: number;
  limit?: number;
  testType?: string;
  activeOnly?: string;
}): [Promise<AxiosResponse<{ items: IABTest[]; page: number; pageSize: number; size: number }>>, Canceler] {
  return api.getWithCancel(`${settings.getApiURI()}/abtest/v1/abtests`, {
    params: {
      ...params,
    },
  });
}

export function getAbtestItem(id: number) {
  return api.http.get(`${settings.getApiURI()}/abtest/v1/abtests/${id}`, {});
}

export function saveAbtestItem(data: any) {
  let requestUrl = `${settings.getApiURI()}/abtest/v1/abtests`;
  requestUrl += data.id ? `/${data.id}` : '';
  return (data.id ? api.http.put : api.http.post)(requestUrl, data);
}

export function saveBundlePackageAbtest(storyId: number, payload: IABTestBundlePackageDto): Promise<AxiosResponse<IApiResult<IBundlePackage>>> {
  const uri = `${settings.getApiURI()}/story-admin/v1/story/${storyId}/episode-bundle-abtests`;
  return api.http.patch(uri, payload);
}

export function deleteAbtestItem(id: number) {
  return api.http.delete(`${settings.getApiURI()}/abtest/v1/abtests/${id}`, {});
}

export function getEpisodeAbTests(seasonId: number) {
  return api.getWithCancel(`${settings.getApiURI()}/abtest/v1/episode-abtests/seasons/${seasonId}/abtest-contents`, {});
}
